// Mock data for Greta Stojanovic portfolio clone
// NOTE: All data below is static/mock content used to replicate the original site.

export const heroImages = [
  "https://images.unsplash.com/photo-1592489427434-fd9696f768b0",
  "https://images.unsplash.com/photo-1652793822141-35666e9db853",
  "https://images.unsplash.com/photo-1652793822017-f06cfd41a0e0",
];

export const hero = {
  name: "Greta Stojanovic",
  roles: [
    "Data Scientist (Python & R)",
    "Statistician",
    "Pianist",
    "Co-Founder of Delphi (pre Beta) - Climate SaaS LLM",
  ],
  welcome: "Welcome to my page!",
  linkedin: "https://www.linkedin.com/in/greta-stojanovic/",
  cv: "https://40a0f70a-3ab5-4fba-9d38-fca83cda902a.filesusr.com/ugd/e0100b_1d4cbfc3fb99467eaa7fea4f4c8b737b.pdf",
};

export const about = {
  heading: "Hi, I'm Greta! Thanks for dropping by...",
  portrait: "/assets/greta-portrait.jpg",
  // Original credential badge was not captured in the archive snapshot.
  credential: null,
  credentialLink:
    "https://www.myequals.net/sharelink/ae51322b-a9dd-4877-bd55-886f449abf7c/2448a17d-89c7-4100-bc2c-a5ed5309ddfd",
  paragraphs: [
    "I'm a multi global award winning tech entrepreneur, Data Scientist, hobby artist and classical pianist - with a love of gardening and the ocean.",
    "In 2019 I was the winner of the Global Techstars Unite to Fight COVID-19 Startup Weekend and in 2021 she won the People's Choice Award in Telstra's International Hackathon.",
    "Following the acquisition of my prior company, I went on to acquire postgraduate degree in Data Science from the Royal Melbourne Institute of Technology (RMIT) and is quoted as \"one of the most prolific students\" renowned Data Scientist Dr. Seyedali Mirjalili has taught.",
    "My passion for human rights, justice and data has led me to building AI solutions in weather prediction and other climate and urban planning related aspects.",
  ],
};

export const portfolio = [
  {
    title: "Lismore Historic Rainfall Records (1895 to 2022)",
    link: "https://gretastojanovic.com.au/lismore-historical-rainfall-records-1895-to-2022/",
    image: "/assets/lismore.png",
    body: [
      "In late February, Lismore, NSW experienced one of its worst floods in history. This dashboard is a deep dive (beyond standard mean focused analyses) into historical rainfall patterns.",
      "References: Bureau of Meteorology (17 April 2022), accessed 17 April 2022",
    ],
  },
  {
    title:
      "International Global Peace Scores Vs Their Respective Ecological Threat Levels",
    link: "https://rpubs.com/s3914796_8782/885527",
    image: null,
    body: [
      "This is a reconstruction of a problematic scatterplot that I found in the media that I had identified as problematic due to a number of best practice visualization techniques. The critique and the code I used to reproduce an improved graph are shown within the details of the portfolio page.",
    ],
  },
  {
    title: "Tokyo 2020 Summer Olympic Games Medal Tally Analysis",
    link: "https://rpubs.com/s3914796_8782/827169",
    image: null,
    body: [
      "This analysis relates to the recent Tokyo 2020 Summer Olympic Games held this year in August (the name honours the original pre covid intended commencement year).",
      "It was interesting to discover on Wikipedia that the official way the IOC deem the winner of the Olympics is by the Gold Medal Tally for the participating nation and that other nation/s also consider the Total Medal Tally as one worthy of noting.",
    ],
  },
];

export const education = [
  {
    year: "2023",
    title: "Master of Data Science (Deferred)",
    org: "The University of Sydney, Australia",
  },
  {
    year: "2022",
    title: "Graduate Certificate in Data Science",
    org: "RMIT University, Australia",
  },
  {
    year: "2021",
    title: "Understanding and Visualizing Data with Python",
    org: "University of Michigan (Coursera)",
  },
  {
    year: "2021",
    title: "Inferential Statistical Analysis with Python",
    org: "University of Michigan (Coursera)",
  },
  {
    year: "2021",
    title: "Fitting Statistical Models to Data with Python",
    org: "University of Michigan (Coursera)",
  },
  {
    year: "2021",
    title: "Python Classes and Inheritance",
    org: "University of Michigan (Coursera)",
  },
  {
    year: "2011",
    title: "Executive Program for Growing Companies",
    org: "Stanford University, Palo Alto, California",
  },
];

export const careerHighlights = [
  "CEO Lust Have it! - exit to Aussie Commerce (now Lux Group) in 2015",
  "Co-Founder and VP of Strategy at Freelancer.com (up to 2011)",
  "VP of Strategy at Freelancer.com 2010-2011",
  "Led capital raising for the Freelancer.com acquisition and formally joined as 2IC to build the team and lead overall strategy and international expansion",
  "AIMIA Awards Sydney 2011 - accepted Best Export Achievement and People's Choice Awards at Cockatoo Island, Sydney",
];

export const awards = [
  {
    year: "2019",
    title: "Winner - Global Techstars Unite to Fight COVID-19 Startup Weekend",
    detail: "$10,000 USD - Data Detectors",
  },
  {
    year: "2019",
    title: "Winner - Australian Techstars Unite to Fight COVID-19 Startup Weekend",
    detail: "Data Detectors",
  },
  {
    year: "2019",
    title: "$25,000 USD Upwork Talent Grant",
    detail:
      "(nb the project did not go ahead as the grant credit received from Upwork had a short expiration date and unable to be used for the purpose granted)",
  },
  {
    year: "2021",
    title: "People's Choice Award Winner - Telstra International Hackathon",
    detail: "$500 - TGreen",
  },
];

export const volunteering = {
  year: "2019",
  org: "Twofold Aboriginal Corporation",
  role:
    "Project Manager and acting Liaison to the Australian National University on behalf of the Twofold Aboriginal Corporation",
  body:
    "I was approached by one of the Directors at Twofold in 2018 who asked if I would like to share my expertise with the Corporation and assist with the redesigning of the website - I was thrilled to be asked and following on from that initial project I requested that I could stay on and continue to be able to be a part of the community and share my skills where possible. I continued on for another 12 months and a part of this eventuated into overseeing the Australian National University on-site Internship in Eden NSW whereby I designed and oversaw the students' KPIs and outcomes respective to their business faculties.",
  links: [
    { label: "Twofold website", url: "https://www.twofoldjigamy.org.au/" },
    {
      label: "CBE Internship Program",
      url: "https://www.cbe.anu.edu.au/study/cbe-internship-program/",
    },
  ],
};

export const referees = [
  {
    name: "Dr Seyedali Mirjalili",
    title: "RMIT University",
    tag: "Highest Regarded AI Data Scientist in the World (2023 Research Magazine)",
    quote:
      "Greta has been one of the most prolific of all of my students at RMIT so far. She's been an active member of our class, providing assistance to other students... articulate in Machine Learning and readily contributes to discussions in the group... Greta has impressed me with her lively intelligence, considerable work ethic and productivity, and her friendliness and readiness to collaborate and assist where she is able.",
  },
  {
    name: "Shumin You",
    title: "Senior Integration Analyst, The Australian National University",
    tag: "",
    quote:
      "In my time working with Greta in Twofold Aboriginal Corporation, she demonstrated an impressive ability to analyse complex systems and data and lead teams of diverse professionals. Her great expertise in data analysis, statistics, and programming, as well as an understanding of the inner workings of the system being analysed helped the team to gain insights and the organization to make informed decisions. She's that kind of go-to person when a powerful set of capabilities are required to lead cross-functional teams and drive business success.",
  },
  {
    name: "Dale McCarthy",
    title: "ex Head of Digital at Fairfax Media & former Board Member of Lust Have it!",
    tag: "",
    quote:
      "I was an investor and board director Lust Have It! when Greta joined as CEO... What impressed me most about Greta in this melee was her steel will, grit, determination and tenacity - absolutely essential characteristics for a start-up CEO and not something that can be taught. She was also whip smart. She could analyse data, read people, navigate challenges, take on feedback and present solutions. And, combined with all that, she is charming, a good manager and generally a great person...",
  },
];

export const connect = {
  heading: "Let's connect!",
  body:
    "I'm excited about all things AI and how this technology renaissance is rapidly opening up incredible ways for us to optimise and thrive as humans. If you'd like to discuss data, science, data science? Please reach out to me on LinkedIn and hopefully we can make the unimaginable possible :)",
  linkedin: "https://www.linkedin.com/in/greta-stojanovic/",
};

export const navLinks = [
  { label: "Home", id: "home" },
  { label: "About", id: "about" },
  { label: "Portfolio", id: "portfolio" },
  { label: "Career", id: "career" },
  { label: "Education", id: "education" },
  { label: "Awards", id: "awards" },
  { label: "Referees", id: "referees" },
  { label: "Connect", id: "connect" },
];
